import { render } from "./commonHeaderOfDIDNumber.vue?vue&type=template&id=0e617504"
import script from "./commonHeaderOfDIDNumber.vue?vue&type=script&lang=js"
export * from "./commonHeaderOfDIDNumber.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__